import React from 'react';
import { useFormContext } from '../../../context/FormContext';
import { Textarea } from '../../ui/Input';

export const QualitativeSection = () => {
  const { data, updateFormSection } = useFormContext();
  const qual = data.form.qualitative;

  const updateField = (field, value) => {
    updateFormSection('qualitative', { ...qual, [field]: value });
  };

  return (
    <div className="space-y-8">
      <div>
        <h4 className="font-serif text-lg text-brand-text mb-4 pb-2 border-b border-brand-border">Product replacement and maintenance practices</h4>
        <div className="space-y-4">
          <Textarea label="How often are products replaced?" value={qual.replacementFreq} onChange={e => updateField('replacementFreq', e.target.value)} />
          <Textarea label="What triggers replacement?" value={qual.triggers} onChange={e => updateField('triggers', e.target.value)} />
          <Textarea label="What maintenance is typically required?" value={qual.maintReqs} onChange={e => updateField('maintReqs', e.target.value)} />
          <Textarea label="Who is responsible for maintenance?" value={qual.maintResp} onChange={e => updateField('maintResp', e.target.value)} />
          <Textarea label="Are there standard maintenance schedules?" value={qual.schedules} onChange={e => updateField('schedules', e.target.value)} />
        </div>
      </div>

      <div>
        <h4 className="font-serif text-lg text-brand-text mb-4 pb-2 border-b border-brand-border">Market context</h4>
        <div className="space-y-4">
          <Textarea label="Describe the market context for the relevant products or services." value={qual.marketContext} onChange={e => updateField('marketContext', e.target.value)} />
          <Textarea label="Describe any changes in customer behaviour during the relevant period." value={qual.behavior} onChange={e => updateField('behavior', e.target.value)} />
          <Textarea label="Describe any pricing pressures or market changes." value={qual.pricing} onChange={e => updateField('pricing', e.target.value)} />
          <Textarea label="Describe any supplier or distribution issues." value={qual.supplierIssues} onChange={e => updateField('supplierIssues', e.target.value)} />
          <Textarea label="Describe any other context that may help assess the RFI." value={qual.other} onChange={e => updateField('other', e.target.value)} />
        </div>
      </div>
    </div>
  );
};